export default __webpack_public_path__ + "static/media/pw2_115-Siddharth-Bisht-Resume.e37c3518.pdf";